/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeeorganizerhint3Inputs */

const en_ticketsfeeorganizerhint3 = /** @type {(inputs: Ticketsfeeorganizerhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers pay only the price, the fee comes out of your payout. Applies to all your events.`)
};

const de_ticketsfeeorganizerhint3 = /** @type {(inputs: Ticketsfeeorganizerhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer zahlen nur den Preis, die Gebühr geht von deiner Auszahlung ab. Gilt für alle deine Events.`)
};

/**
* | output |
* | --- |
* | "Buyers pay only the price, the fee comes out of your payout. Applies to all your events." |
*
* @param {Ticketsfeeorganizerhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeeorganizerhint3 = /** @type {((inputs?: Ticketsfeeorganizerhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeeorganizerhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeeorganizerhint3(inputs)
	return de_ticketsfeeorganizerhint3(inputs)
});
export { ticketsfeeorganizerhint3 as "ticketsFeeOrganizerHint" }